import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuType } from '../../../../system/system-dtos';
import { MaintainService } from '../maintain.service';
import { DataSource } from './data-source';
import { MaintainDataSource } from './maintain-data-source';
import { QueryDataSource } from './query-data-source';
import { EntityGroupDataSource } from './entity-group-data-source';
import { CassandraDataSource } from './cassandra-data-source';

@Injectable()
export class DataSourceFactory {
  private map: Map<MenuType, DataSource>;

  constructor(
    private route: ActivatedRoute,
    private maintainService: MaintainService,
    private queryDataSource: QueryDataSource
  ) {
    const maintainDataSource = new MaintainDataSource(route, maintainService);
    const cassandraDataSource = new CassandraDataSource(maintainService);

    this.map = new Map<MenuType, DataSource>();
    this.map.set(MenuType.MAINTAIN, maintainDataSource);
    this.map.set(MenuType.ELASTIC, queryDataSource);
    this.map.set(MenuType.CASSANDRA, cassandraDataSource);
    this.map.set(
      MenuType.ENTITY_GROUP,
      new EntityGroupDataSource(route, maintainService, maintainDataSource, queryDataSource, cassandraDataSource)
    );
  }

  get(type: MenuType) {
    const dataSource = this.map.get(type);
    return dataSource || this.get(MenuType.MAINTAIN);
  }
}
